/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { faFilePdf, faFilePowerpoint, faFileWord } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { __ } from '../../../helpers/translations';
import { useAuthContext } from '../../../hooks/useAuthContext';
import Section from '../../common/Section';
import Page from '../common/Page';
import SignedOut from '../common/SignedOutDialog';
import SectionHeader from '../landing/SectionHeader';

const resources = [
  {
    title: 'Interpersonal Conflict Management',
    subTitle: 'Coaching Tool',
    text: 'Give individuals tools to navigate a conflict',
    links: [
      {
        icon: <FontAwesomeIcon icon={faFileWord} />,
        text: 'Workbook',
        url: 'https://www.dropbox.com/sh/19hwelsql0s0ntj/AADRtFkRx1p7xDtdwsaonyDxa/Interpersonal%20CM?dl=0&preview=Activities+Workbook+Final.docx',
      },
      {
        icon: <FontAwesomeIcon icon={faFilePdf} />,
        text: 'Tips for Difficult Conversations',
        url: 'https://www.dropbox.com/sh/19hwelsql0s0ntj/AADRtFkRx1p7xDtdwsaonyDxa/Interpersonal%20CM?dl=0&preview=ITP+-+Difficult+Conversations.pdf',
      },
      {
        icon: <FontAwesomeIcon icon={faFileWord} />,
        text: 'Simulation scenario activities to practice',
        url: 'https://www.dropbox.com/sh/19hwelsql0s0ntj/AADRtFkRx1p7xDtdwsaonyDxa/Interpersonal%20CM?dl=0&preview=Simulations+Final.doc',
      },
    ],
  },
  {
    title: 'Team Contracts',
    subTitle: '75-90 minutes',
    text: 'Develops norms involving various aspects of team functioning.',
    links: [
      {
        icon: <FontAwesomeIcon icon={faFileWord} />,
        text: 'ITP Lab Team Contract',
        url: 'https://www.dropbox.com/sh/19hwelsql0s0ntj/AACpKOnExQNpBBrdUNdYa9UWa/Team%20Contract?dl=0&lst=&preview=General+Team+Contract.docx',
      },
      {
        icon: <FontAwesomeIcon icon={faFilePowerpoint} />,
        text: 'Slide Deck',
        url: 'https://www.dropbox.com/sh/19hwelsql0s0ntj/AACpKOnExQNpBBrdUNdYa9UWa/Team%20Contract?dl=0&lst=&preview=Team+Contract+Workshop.pptx',
      },
      {
        icon: <FontAwesomeIcon icon={faFileWord} />,
        text: 'Tips for facilitators',
        url: 'https://www.dropbox.com/sh/19hwelsql0s0ntj/AADCHrbyxWuup5mVjhBlXlhya/SUIT?dl=0&preview=Tips+for+Facilitators.doc',
      },
    ],
  },
  {
    title: 'SUIT Model for Team Conflict Management',
    subTitle: '60-90 minutes',
    text: 'Encourage effective team conflict management during decision making',
    links: [
      {
        icon: <FontAwesomeIcon icon={faFilePowerpoint} />,
        text: 'Slide Deck',
        url: 'https://www.dropbox.com/sh/19hwelsql0s0ntj/AADCHrbyxWuup5mVjhBlXlhya/SUIT?dl=0&preview=SUIT+Training+PPT+Deck.pptx',
      },
      {
        icon: <FontAwesomeIcon icon={faFileWord} />,
        text: 'Brainstorming',
        url: 'https://www.dropbox.com/sh/19hwelsql0s0ntj/AADCHrbyxWuup5mVjhBlXlhya/SUIT?dl=0&preview=1.+Brainstorming.doc',
      },
      {
        icon: <FontAwesomeIcon icon={faFileWord} />,
        text: 'Structured role play',
        url: 'https://www.dropbox.com/sh/19hwelsql0s0ntj/AADCHrbyxWuup5mVjhBlXlhya/SUIT?dl=0&preview=2.+Structured+Role-Play.doc',
      },
      {
        icon: <FontAwesomeIcon icon={faFileWord} />,
        text: 'Survival task',
        url: 'https://www.dropbox.com/sh/19hwelsql0s0ntj/AADCHrbyxWuup5mVjhBlXlhya/SUIT?dl=0&preview=3.+Survival+Task+With+Answers.doc',
      },
      {
        icon: <FontAwesomeIcon icon={faFileWord} />,
        text: 'SUIT team contract',
        url: 'https://www.dropbox.com/sh/19hwelsql0s0ntj/AADCHrbyxWuup5mVjhBlXlhya/SUIT?dl=0&preview=4.+SUIT+Team+Contract.docx',
      },
      {
        icon: <FontAwesomeIcon icon={faFileWord} />,
        text: 'Tips for facilitators',
        url: 'https://www.dropbox.com/sh/19hwelsql0s0ntj/AADCHrbyxWuup5mVjhBlXlhya/SUIT?dl=0&preview=Tips+for+Facilitators.doc',
      },
    ],
  },
];

function Resources() {
  const { user } = useAuthContext();

  if (!user) {
    return <SignedOut />;
  }
  console.log('resources');
  return (
    <Page>
      <Section>
        <SectionHeader
          title={__('G299')}
          subtitle=""
        />
        <Row className="my-3 g-6 justify-content-md-center">
          {resources.map((resource, index) => (
            <Col lg={6} key={`resource-${index}`}>
              <Card>
                <Card.Body>
                  <Card.Title as="h5">
                    {resource.title}
                  </Card.Title>
                  <Card.Text style={{ fontStyle: 'italic' }}>
                    {resource.subTitle}
                  </Card.Text>
                  <Card.Text>
                    {resource.text}
                  </Card.Text>
                  {resource.links.map((link, linkIndex) => (
                    <Row key={`resource-${index}-button-${linkIndex}`} style={{ padding: '3px', fontSize: 14 }}>
                      <Col style={{ maxWidth: '10px', paddingRight: '0.5em' }}>
                        {link.icon}
                      </Col>
                      <Col>
                        <a href={link.url} target="_blank" rel="noreferrer">
                          {link.text}
                        </a>
                      </Col>
                    </Row>
                  ))}
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Section>
    </Page>
  );
}

Resources.propTypes = {
};

export default Resources;
